

































import { Component, Prop, Vue } from "vue-property-decorator";

import { editorData } from '@/data/EditorData';
import { ElementTypeComplexList, IElementTypeComplexList } from '@/data/ElementTypeModel';
import ComplexProperty from "./ComplexProperty.vue";

@Component({
    components: {
        ComplexProperty
    }
})
export default class ComplexListProperty extends Vue {

    @Prop({ type: String })
    name!: string;

    @Prop({ type: Object })
    value!: any;

    @Prop({ type: Object })
    type!: IElementTypeComplexList;

    addItem() {
        let counter = 0;
        let name;
        do {
            name = "NewItem" + (counter || "");
            counter++;
        } while ((this.value || {})[name]);
        this.$emit("input", {
            ...this.value,
            [name]: JSON.parse(JSON.stringify(this.type.defaultElement))
        });
    }

    removeItem(key: string) {
        const copy = JSON.parse(JSON.stringify(this.value));
        delete copy[key];
        this.$emit("input", copy);
    }

    changePath(p: string) {
        this.$emit("change-path", [p]);
    }

}
